<script lang="ts">
  export let label: string
  export let name: string
  export let value: boolean
  export let disabled: boolean = false
  export let dataRole: string | undefined = undefined
</script>

<div class="py-2 checkbox-list">
  <label class="flex items-center">
    <input type="checkbox" class="shrink-0" data-role={dataRole} {name} {disabled} bind:checked={value} />
    <span class="ml-1">{label}</span>
  </label>
</div>
